/**
 * Created by divyanshverma on 11/24/16.
 */
import moment from 'moment-timezone';
import * as _ from 'underscore';
import 'jquery-ui/ui/widgets/autocomplete';

class OBTOGridExtended {
    constructor(t, set, s, c) {
        this.table = t;
        this.settings = set;
        this.scope = s;
        this.collection = c;
        // console.log(JSON.stringify(this.settings));
    }
    
    move(x, y) {
        this.x = x;
        this.y = y;
        // console.log("ES6" + x);
    }
    
    returnHyperLinkPage() {
        
        return (cellValue, options, rowdata, action) => {
            // console.log(cellValue);
            // console.log(options);
            // console.log(rowdata);
            // console.log(action);
            return "<a target='_blank' href='" + cellValue + "'>View </a>";
        };
    }
    
    returnHyperLink(_options, rootScope) {
        const _new = _options.hasOwnProperty('embedded') ? _options.embedded: false;
        const memberView = _options.hasOwnProperty('memberView') ? _options.memberView: false;
        const memberFunction = _options.hasOwnProperty('memberFunction') ? _options.memberFunction: false;
        
        return (cellValue, options, rowdata, action) => {
            
            // console.log(cellValue);
            // console.log(this.settings);
            // console.log(rowdata);
    
            window.myFunction = () => {
                // alert("Hello World");
            };
            
            const target = _new ? '_blank' : '';
            
            if(memberView){
                
                if(memberFunction){
                    return `<a href='#' onclick="${memberFunction}();return false;">${cellValue}</a>`;
                }
                return `<a href='#'>${cellValue}</a>`;
            }
            
            if (_.isUndefined(cellValue) || cellValue === null)
                return `<a href='${this.collection}/${rowdata._id}' target=${target}></a>`;
            
            if (cellValue.toString().indexOf('T') > -1 && cellValue.toString().indexOf('Z') > -1)
                return `<a title="${moment.tz(cellValue, this.settings.dateTimeFormat, this.settings.timezone).utc().fromNow()}" href='${this.collection}/${rowdata._id}' target=${target}>${moment.tz(cellValue, this.settings.timezone).format(this.settings.dateTimeFormat)}</a>`;
            
            if (typeof cellValue === 'object')
                return `<a href='${this.collection}/${rowdata._id}' target=${target}>${cellValue.label}</a>`;
            
            return `<a href='${this.collection}/${rowdata._id}' target=${target}>${cellValue}</a>`;
        };
    }
    
    returnHyperLinkNewWindow() {
        
        return (cellValue, options, rowdata, action) => {
            if (_.isUndefined(cellValue) || cellValue === null)
                return "<a target='_blank' href='/o/" + this.collection + "/" + rowdata._id + "' ></a>";
            
            if (cellValue.toString().indexOf('T') > -1 && cellValue.toString().indexOf('Z') > -1)
                return "<a target='_blank' href='/o/" + this.collection + "/" + rowdata._id + "' >" + moment.tz(cellValue, this.settings.timezone).format(this.settings.dateTimeFormat) + "</a>";
            
            if (typeof cellValue === 'object')
                return "<a target='_blank' href='/o/" + this.collection + "/" + rowdata._id + "' >" + cellValue.label + "</a>";
            
            return "<a target='_blank' href='/o/" + this.collection + "/" + rowdata._id + "' >" + cellValue + "</a>";
        };
        
    }
    
    password() {
        return (cellvalue, options, rowdata) => {
            return "************************";
        };
    }
    
    unFormatReference() {
        return (cellvalue, options, cell) => {
            ////console.log(cellvalue);
            ////console.log(options);
            ////console.log(cell);
            //$("input", cell).focus();
            return (_.isUndefined(cellvalue) || cellvalue === 'undefined') ? "" : cellvalue;
        };
    }
    
    custom_datepicker() {
        
        return (value, options) => {
            
            let $dtpContainer = $('<div class="input-group date" style="position: absolute;padding: 4px;width: 10%;margin-top: -11px;"></div>');
            let $dtp = $('<input type="text" class="form-control"/>');
            // let $addOn = $('<div class="input-group-addon"><span class="glyphicon glyphicon-th"></span></div>');
            
            let format = "dd-mm-yyyy";
            if (this.settings.dateFormat === 'MM/DD/YYYY' || this.settings.dateFormat === 'MM-DD-YYYY')
                format = 'mm-dd-yyyy';
            
            $dtp.datepicker({
                container: $dtpContainer,
                changeMonth: true,
                changeYear: true,
                autoclose: true,
                orientation: 'bottom right',
                format: format
            }).on('changeDate', function (e) {
                // console.log(e);
                // $dtp.val(moment.utc(e.date).format(format)).trigger(jQuery.Event( 'keypress', { keyCode: 13, which: 13 } ));
            });
            
            $dtp.val(value);
            
            // $dtp.focus();
            
            $dtpContainer.append($dtp);
            
            return $dtpContainer;
            
        };
    }
    
    static custom_datepicker_value(elem, op, v) {
        
        if (op === 'set') {
            $(elem).find("input:text").val(v);
        }
        return $(elem).find("input:text").val();
    }
    
    autocomplete_element(col, storeId, root) {
        return (value, options) => {
            // console.log("Hi")
            const collection = col.refer_collection;
            const df = col.display_field;
            const n = col.name;
            const dependency = col.dependency;
            const sourceFilter = col.source_filter;
            
            let selRowId = this.table.jqGrid('getGridParam', 'selrow');
            let celValue = this.table.jqGrid('getCell', selRowId, dependency);
            let url = "";
            let format = {};
            
            let displayfield = df;
            let displayfieldGroup = "";
            let remainingProjection = "";
            
            if (df && df.toString().indexOf(',') > -1) {
                let split = df.split(',');
                displayfield = split[0];
                displayfieldGroup = split[1];
                
            }
            
            if (displayfieldGroup.length > 0)
                remainingProjection = ',' + displayfieldGroup;
            
            if (_.has(storeId, n))//If exists delete it first
                delete storeId[n];
            // return DOM element from jQuery object
            //create input element
            let $ac = $('<input type="text" style="width: 80%;" class="form-control" placeholder="" autocomplete="off" id="' + options.id + '"/>');
            //setting value to the one passed from jqGrid
            $ac.val(value);
            //creating autocomplete
            $ac.autocomplete(
                {
                    source: function (request, response, term) {
                        const param = request.term; //values we enter to filter autocomplete
                        url = `/o/recs/${collection}?nd=${new Date().getTime()}&stream=true&project=${displayfield}${remainingProjection}&oquery=${displayfield}==${param}`;
                        
                        if (dependency && dependency.length !== 0) {
                            url += `,${dependency}.label=${celValue}`;
                        }
    
                        if (sourceFilter && sourceFilter.toString().indexOf('=') > -1) {
                            url += `,${sourceFilter}`;
                        }
                        
                        if (root.ob.eduCollections && root.ob.eduCollections.includes(collection)) {
                            url += `,session=${root.session},domain=INedu:${root.domain}`;
                        }
                        
                        $.ajax({
                            url: url,
                            dataType: "json",
                            type: "GET",
                            beforeSend: function (jqXHR, settings) {
                                jqXHR.setRequestHeader("Authorization", 'Bearer ' + JSON.parse(localStorage.getItem("ob")).token);
                            },
                            success: function (data) {
                                //console.log(JSON.stringify(data));
                                if (collection === 'pltf_user') {
                                    let insertGlobalUser = {};
                                    insertGlobalUser[displayfield] = 'Global';
                                    insertGlobalUser._id = 'global';
                                    data.push(insertGlobalUser);
                                }
                                
                                
                                response($.map(data, function (item) {
                                    //console.log("typeof displayfieldGroup : " + displayfieldGroup)
                                    //console.log("value displayfieldGroup : " + JSON.stringify(item))
                                    if (displayfieldGroup.length !== 0) {
                                        
                                        if (typeof item[displayfieldGroup] === "object") {
                                            format = {
                                                //can add number of attributes here
                                                id: item._id,
                                                label: item[displayfield] + ' - ' + item[displayfieldGroup].label
                                            };
                                        } else {
                                            format = {
                                                //can add number of attributes here
                                                id: item._id,
                                                label: item[displayfield] + ' - ' + item[displayfieldGroup]
                                            };
                                        }
                                        
                                    } else {
                                        format = {
                                            //can add number of attributes here
                                            id: item._id,
                                            label: item[displayfield]
                                        };
                                    }
                                    
                                    return format;
                                }));//END Response
                                
                            },//END Success
                        });//END AJAX
                    },
                    select: function (event, ui) {
                        storeId[n] = ui.item.id;
                    }
                    
                }
            ).data("ui-autocomplete")._renderItem = (ul, item) => {
                $(ul).addClass("list-group").addClass("oblistitemwidth");
                
                return $("<li class=\"btn list-group-item list-group-item-info\">")
                    .append("<a>" + item.label + "</a>")
                    .appendTo(ul);
            };
            
            return $ac.get(0);
            
        };
    }
    
    autocomplete_value() {
        return (elem, op, v) => {
            if (op === 'set') {
                $(elem).val(v);
            }
    
            if (op === "get") {
                return $(elem).val();
            }
        };
    }
    
    dateTimeFormatter() {
        return (cellValue, options, rowdata, action) => {
            if (!_.isUndefined(cellValue) && cellValue != null) {
                if (cellValue.indexOf('T') > -1 && cellValue.indexOf('Z') > -1)
                    return moment.tz(cellValue, this.settings.timezone).format(this.settings.dateTimeFormat);
                
                return moment.tz(cellValue, this.settings.dateTimeFormat, this.settings.timezone).format(this.settings.dateTimeFormat);
            }
            return "";
        };
    }
    
    dateTimeFormatterSetTitle() {
        return (rowId, cellValue, rawObject, cm, rdata) => {
            
            if(cellValue.startsWith('<a')){
                return;
            }
            // console.log(moment(moment.tz(cellValue, this.settings.dateTimeFormat, this.settings.timezone).utc()).fromNow());
            if (!_.isUndefined(cellValue)) {
                // if (cellValue.indexOf('T') > -1 && cellValue.indexOf('Z') > -1)
                //     return `title=${moment(moment.tz(cellValue, this.settings.dateTimeFormat, this.settings.timezone).utc()).fromNow()}`;
                return `title="${moment.tz(cellValue, this.settings.dateTimeFormat, this.settings.timezone).utc().fromNow()}"`;
            }
            return "";
        };
    }
    
    dateFormatter() {
        return (cellValue, options, rowdata, action) => {
            
            if (!_.isUndefined(cellValue) && cellValue != null) {
                if (cellValue.indexOf('T') > -1 && cellValue.indexOf('Z') > -1) {
                    return moment.tz(cellValue, this.settings.timezone).format(this.settings.dateFormat);
                }
                // console.log("I DONT got date 22222:" + cellValue);
                
                if (!_.isUndefined(cellValue)) {
                    // return moment(cellValue, this.dateFormat).format(this.dateFormat);
                    return moment.tz(cellValue, this.settings.dateFormat, this.settings.timezone).format(this.settings.dateFormat);
                }
                
            } else {
                return "";
            }
        };
    }
    
    pickDateTime() {//cellvalue, options, cell
        
        return (element) => {
            $(element).focus(function () {
                // this.select();
            });
            $(element).datetimepicker({
                // dateFormat: this.settings.dateFormat,//$.datepicker.RFC_2822,
                // timeFormat: 'hh:mm tt',
                // showSecond: false,
                // showMillisec: false,
                // showMicrosec: false,
                // showTimezone: false,
                // onClose: function (val, ins) {
                //     //console.log(val);
                //     //ins.datepicker("destroy");
                // }
                format: this.settings.dateTimeFormat
                // defaultDate: "11/1/2013",
                // disabledDates: [
                //     moment("12/25/2013"),
                //     new Date(2013, 11 - 1, 21),
                //     "11/22/2013 00:53"
                // ]
            }).keydown(function (e) {
                let code = e.which || e.keyCode;
                if (code === 9)
                    $(this).datepicker('destroy');
            });
        };
    }
    
    pickDate() {
        return (element) => {
            
            let _format = "dd-mm-yyyy";
            if (this.settings.dateFormat === 'MM/DD/YYYY' || this.settings.dateFormat === 'MM-DD-YYYY') {
                _format = 'mm-dd-yyyy';
            }
            
            
            $(element).focus(function () {
                this.select();
            });
            
            $(element).datepicker({
                autoclose: true,
                maxViewMode: 2,
                todayBtn: "linked",
                orientation: "auto bottom",
                format: _format
                // format: {
                //     toDisplay: function (date, format, language) {
                //         let d = new Date(date);
                //         d.setDate(d.getDate());
                //         return d.toISOString();//moment(d.toISOString()).format(_format);
                //     },
                //     toValue: function (date, format, language) {
                //         let d = new Date(date);
                //         d.setDate(d.getDate());
                //         return new Date(d);
                //     }
                // }
            });
            
            $(element).focus(function () {
                this.select();
            });
            
        };
        
    }
    
    scriptFormatter() {
        return (cellvalue, options, rowdata, action) => {
            return (_.isUndefined(cellvalue) || cellvalue === null) ? "" : "Script...";
        };
    }
    
    unformatScriptFormatter() {
        return (cellvalue, options, rowdata, action) => {
            return cellvalue;
        };
    }
    
    gselectFormatter(cellName, dataStore) {

        return (cellvalue, options, rowdata, action) => {
            if (cellvalue && typeof cellvalue === 'object') {
                if (_.has(cellvalue, 'label') && _.has(cellvalue, 'value')) {
                    if(!dataStore[options.rowId]){
                        dataStore[options.rowId] = {};
                    }
                    dataStore[options.rowId][cellName] = rowdata[cellName];
                    return `<a href=${options.colModel.refer_collection}/${cellvalue.value}>${cellvalue.label}</a>`;
                } else {
                    return "";
                }
                
            }
            
            if (_.isUndefined(cellvalue) || cellvalue === null)
                return "";
            
            if (typeof cellvalue === 'string') {
                return "<a href='" + options.colModel.refer_collection + "/" + cellvalue + "' >" + cellvalue + "</a>";
            }
            
        };
        
    }
    
    multiSelect() {
        
        return (cellvalue, options, rowdata, action) => {
            let returnSet = [];
            if (cellvalue && cellvalue instanceof Array) {
                _.each(cellvalue, (item) => {
                    returnSet.push(item.text);
                });
            }
            return returnSet.join();
        };
    }
    
    unFormatMReference() {
        return (cellvalue, options, cell) => {
            // console.log(cellvalue);
            // console.log(options);
            // console.log($(cell));
            // $("input", cell).focus();
            return cellvalue;
        };
    }
    
    generalFormatter() {
        return (cellvalue, options, rowdata, action) => {
            return (_.isUndefined(cellvalue) || cellvalue === null) ? "" : cellvalue;
        };
        
    }
    
    optionFormatter() {
        return (cellvalue, options, rowdata, action) => {
            if(typeof cellvalue === "undefined"){
                return "";
            }
            let data = options.colModel.editoptions.value;
            return (_.isUndefined(data[cellvalue]) || data[cellvalue] === null) ? `<span style="color:blue">${cellvalue}</span>` : data[cellvalue];
        };
    }
    
    unformatOptions(cellvalue, options, cell) {
        return (cellvalue, options, rowdata, action) => {
            return cellvalue;
        };
    }
    
    validatePositive() {
        return (value, column) => {
            if (isNaN(value) || value === null)
                return "";
            else
                return value;
        };
    }
    
    booleanFormatter() {
        return (cellvalue, options, rowObject) => {
            ////console.log("Cellval" + typeof cellvalue);
            ////console.log("Cellval" + cellvalue);
            ////console.log("options" + JSON.stringify(options));
            ////console.log("rowdata" + JSON.stringify(rowObject));
            if (this.collection === "attendance") {
                switch (cellvalue) {
                    case true:
                        return "P";
                    case false:
                        return "A";
                    case "false":
                        return "A";
                    case "true":
                        return "P";
                    default:
                        return cellvalue ? cellvalue : false;
                }
            }
            return cellvalue ? cellvalue : false;
        };
        
    }
    
    formatImage() {
        return (cellValue, options, rowObject) => {
            let imgSrc = "data:image/png;base64," + window.btoa(cellValue);
            let imageHtml = "<img height='28' width='30' alt='' src='" + imgSrc + "'/>";//originalValue='" + cellValue + "'
            return imageHtml;
        };
    }
    
    imageUnFormat() {
        return (cellValue, options, cell) => {
            return $('img', cell).attr('src');
        };
    }
    
    processRules() {
        //console.log()
    }
}

export default OBTOGridExtended;
